import { createSelector } from '@reduxjs/toolkit';
export var selectCommissionInfo = createSelector(function (state) { return state.commission; }, function (_a) {
    var commission = _a.commission;
    return {
        name: (commission === null || commission === void 0 ? void 0 : commission.name) || '',
        description: (commission === null || commission === void 0 ? void 0 : commission.description) || '',
    };
});
export var selectAirlineCommissions = createSelector(function (state) { var _a; return ((_a = state.commission.commission) === null || _a === void 0 ? void 0 : _a.airlines_commissions) || []; }, function (commissions) { return commissions; });
export var selectAirlineCommission = createSelector([selectAirlineCommissions, function (_, id) { return id; }], function (commissions, id) {
    return commissions.find(function (commission) {
        return commission.id === id;
    });
});
export var selectCommissionModuleHasEdition = createSelector(function (state) { return state.commission.commission; }, function (state) { return state.commission.initialData; }, function (currentData, initialData) {
    var current = JSON.stringify(currentData);
    var initial = JSON.stringify(initialData);
    return current !== initial;
});
export var selectUpdatedCommissionModule = createSelector(function (state) { return state.commission.commission; }, function (commission) { return commission; });
